import { useState, useEffect } from 'react';
import { ProfileManagement } from '../profile';
import { callApi } from '../../services/ApiServices';
import { useGlobalStates } from "../../utlis/ClubsContext";
import toast from 'react-hot-toast';
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom';


const Header = () => {
  const [showProfile, setShowProfile] = useState(false);
  const[profileData, setProfileData] = useState()
  const[loading, setLoading] = useState(false)
  const {setUserRole, userRole} = useGlobalStates()
  const navigate = useNavigate()

    const fetchProfile = async () => {
      try {
        setLoading(true);

        const response = await callApi({
          method: "get",
          url: "admin/profile",
        });
        console.log("profile", response);
        if(response.status==200){
          if(response?.data?.status !== "active"){
            toast.error("Your account is inactive. Please contact support.",{id:"accountInactiveToast"});
            Cookies.remove('Admin_Token');
            Cookies.remove('AccessPermission');
            setTimeout(() => {             
              navigate('/login')
            },1000)
          }
          setUserRole(response?.data?.access_permission)
          setProfileData(response?.data);
          setLoading(false);
          
        }
      } catch (error) {
        console.error("Error fetching contact us listing:", error);
        setLoading(false);
      }
    };

    useEffect(() => {
      fetchProfile();
    },[])
const getInitials = (name = "") => {
  if (!name) return "";
  const words = name.trim().split(" ");
  if (words.length === 1) return words[0][0].toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
};


  return (
    <>
      <header className="bg-white rounded-[10px] h-[50px] flex items-center justify-end px-4 m-5 mb-0 flex-shrink-0">
        <div className="flex justify-end">
          <button
            onClick={() => setShowProfile(true)}
            className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center hover:bg-gray-300 transition-colors cursor-pointer"
          >
            <span className="text-sm font-semibold text-gray-700">{getInitials(profileData?.name)}</span>
          </button>
        </div>
      </header>

      {showProfile && <ProfileManagement onClose={() => setShowProfile(false)} profileData={profileData} fetchProfile={fetchProfile}/>}
    </>
  );
};

export default Header;
